// extracted by mini-css-extract-plugin
module.exports = {"introduction":"Introduction_introduction__4_qWo","blink":"Introduction_blink__hjVpp"};